/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnalyticLegendEntry } from './analyticLegendEntry';


/**
 * Legend block for the map view of an analysis model (one legend block per icon property). Many-to-one mappings to AnalyticLegendEntry and AnalyticProcess are necessary.
 */
export interface AnalyticLegend { 
    /**
     * Internal AnalyticLegend Key
     */
    id: number;
    /**
     * Internal AnalyticProcess Key
     */
    analyticProcessId: number;
    /**
     * Sort order of the legend block
     */
    sort: number;
    /**
     * Title of the legend block
     */
    title: string;
    /**
     * Property of the legend block (icon property)
     */
    property: string;
    /**
     * Description of the legend block
     */
    description: string;
    analyticLegendEntry: Array<AnalyticLegendEntry>;
}

